import { Component } from '@angular/core';
import {HeroNutricionDieteticaComponent} from "./hero-nutricion-dietetica/hero-nutricion-dietetica.component";
import {InfoComponent} from "../home/info/info.component";
import {ImportantItemsNutricionComponent} from "./important-items-nutricion/important-items-nutricion.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";

@Component({
  selector: 'app-nutricion-dietetica',
  standalone: true,
    imports: [
        HeroNutricionDieteticaComponent,
        InfoComponent,
        ImportantItemsNutricionComponent,
        FooterPersonaComponent
    ],
  templateUrl: './nutricion.dietetica.component.html',
  styleUrl: './nutricion-dietetica.component.css'
})
export class NutricionDieteticaComponent {

}
